import { createContext, useContext, useState, ReactNode } from "react";
import type { Vault } from "./vault-types";

export type { Vault };

interface VaultContextValue {
  selected: Vault[];
  toggle: (v: Vault) => void;
  set: (v: Vault[]) => void;
}

const Ctx = createContext<VaultContextValue | null>(null);

export function VaultProvider({ children }: { children: ReactNode }) {
  const [selected, setSelected] = useState<Vault[]>(["main"]);
  const toggle = (v: Vault) => setSelected(prev =>
    prev.includes(v) ? prev.filter(x => x !== v) : [...prev, v],
  );
  return <Ctx.Provider value={{ selected, toggle, set: setSelected }}>{children}</Ctx.Provider>;
}

export function useVault() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useVault must be used within VaultProvider");
  return ctx;
}
